/* eslint-disable no-unexpected-multiline */
import types from '../types'
import Helpers from '../Helpers.js'
// import {changeQuestion} from './changeQuestion2'
// import {fetchSectionResponse} from './fetchSectionResponse'

export const fetchSubSectionResponse =
(isLastSubSection) => (dispatch, getState) => {
  const {
    // currentPqId,
    // currentPqIdIndex,
    // currentUfqIdIndex,
    prompt1Response,
    // selectedSectionIndex,
    // selectedSubSectionIndex,
    selectedSectionName,
    selectedSubSectionName,
  } = getState().userReducer
  const data = {
    major_section: selectedSectionName,
    minor_section: selectedSubSectionName,
    data: prompt1Response,
  }
  Helpers.fetchPostJson(
      process.env.REACT_APP_API_URL + '/submit_minor_prompt',
      data,
      {
        orgId: process.env.REACT_APP_ORG_ID,
        authKey: process.env.REACT_APP_AUTH_KEY,
      },
  )
      .then((res) => {
        const newPrompt1Response = {
          ...prompt1Response,
        }

        let parsedStr = ''
        const answer = res?.data?.answer
        if (answer) {
          parsedStr =
            Helpers.removeCheckbox(
                answer.replace(/###/gi, '').replace(/\**/g, ''),
            )
        }
        newPrompt1Response
            [selectedSectionName]
            [selectedSubSectionName]
            ['Response'] =
            parsedStr || 'n/a'
        const isSectionReadyForReview = isLastSubSection
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            prompt1Response: newPrompt1Response,
            isSectionReadyForReview,
          },
        })
        // console.log('should not fetch doc')
        // const changeQuestionProps = {
        //   newSubSectionIndex: selectedSubSectionIndex + 1,
        //   newPqIdIndex: currentPqIdIndex + 1,
        //   newUfqIdIndex: currentUfqIdIndex + 1,
        //   currentPqId,
        //   currentPqIdIndex,
        //   currentUfqIdIndex,
        //   prompt1Response,
        //   selectedSectionIndex,
        //   selectedSubSectionIndex,
        //   selectedSectionName,
        //   selectedSubSectionName,
        //   // even though it is review, currently skip is prevented
        //   isReview: false,
        //   isSubSectionReadyForReview: false,
        // }
        // dispatch(changeQuestion(changeQuestionProps))
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            isSubSectionReadyForReview: false,
            isReview: false,
            typeFormStep: 'response-review',
            isLoading: false,
          },
        })
      })
      .catch((err) => {
        const newPrompt1Response = {
          ...prompt1Response,
        }
        newPrompt1Response
            [selectedSectionName]
            [selectedSubSectionName]
            ['Response'] =
              'n/a'
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            isLoading: false,
            userMessage:
              // eslint-disable-next-line max-len
              `Error getting a response for ${selectedSubSectionName}. Please try again`,
            notificationIcon: 'warning',
            notificationType: 3,
          },
        })
        console.log('Error getting minor-element response', err)
      })
}
